import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=30912b06"
import script from "../services/terms-of-service.js?vue&type=script&lang=js&external"
export * from "../services/terms-of-service.js?vue&type=script&lang=js&external"
import style0 from "../assets/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../assets/css/terms-of-service.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports